import React, { useEffect, useState } from "react";
import {
  Menu,
  Icon,
  DropdownMenu,
  Dropdown,
  DropdownItem,
  Popup,
} from "semantic-ui-react";
import { Link, useLocation } from "react-router-dom";
import { Permission } from "../../../../api";
import { useAuth } from "../../../../hooks";
import "./AdminMenu.scss";
import { PeerAppButton } from "../PeerAppButton/PeerAppButton";
import {
  hasPermission,
  isAdmin,
  isMaster,
} from "../../../../utils/checkPermission";
import { useLanguage } from "../../../../contexts";
import iconProduccion from "../../../../assets/svg/produccion 1.svg";
import iconSocial from "../../../../assets/svg/Capa 1.svg";
import iconEnergia from "../../../../assets/svg/Capa 4.svg";
import iconVehiculos from "../../../../assets/svg/Capa 5.svg";
import iconAgua from "../../../../assets/svg/Capa 6.svg";
import iconEfluentes from "../../../../assets/svg/Rectangle 184.svg";
import iconResiduos from "../../../../assets/svg/Group.svg";
import iconAireEmision from "../../../../assets/svg/Group 41.svg";
import iconDatos from "../../../../assets/svg/Vector 17.svg";

const SvgIcon = ({ src, alt }) => (
  <img src={src} alt={alt} className="menu-sub-icon" />
);

const permissionController = new Permission();

function TooltipWrapper({ collapsed, content, children }) {
  if (!collapsed) return children;
  return (
    <Popup
      content={content}
      position="right center"
      trigger={children}
      inverted
      size="small"
    />
  );
}

export function AdminMenu({ collapsed, setCollapsed }) {
  const { pathname } = useLocation();
  const { user, accessToken } = useAuth();
  const { role, company, site } = user || {};

  const { translations } = useLanguage();

  const t = (key) => translations[key] || key;

  const [permissionActive, setPermissionsActive] = useState([]);

  const toggleCollapse = () => {
    setCollapsed((prev) => {
      const newState = !prev;
      localStorage.setItem("adminMenuCollapsed", newState);
      return newState;
    });
  };

  const isCurrentPath = (path) => pathname === path;

  const isParentPath = (...prefixes) =>
    prefixes.some((p) => pathname.startsWith(p));

  useEffect(() => {
    (async () => {
      try {
        setPermissionsActive([]);
        if (role) {
          const response = await permissionController.getMyPermissions(
            accessToken,
            true
          );
          setPermissionsActive(response);
        }
      } catch (error) {
        console.error(error);
        setPermissionsActive([]);
      }
    })();
  }, [role]);

  return (
    <div style={{ width: collapsed ? "70px" : "200px" }}>
    <Menu fluid vertical className="admin-menu">
      {
        <>
          {isMaster(role) ||
          isAdmin(role) ||
          hasPermission(permissionActive, role._id, "dashboard", "menu") ? (
            <TooltipWrapper collapsed={collapsed} content={t("dashboard")}>
              <Menu.Item
                as={Link}
                to="/admin/dashboard"
                active={isCurrentPath("/admin/dashboard")}
                className="admin-nav-item"
              >
                {!collapsed && t("dashboard")}
              </Menu.Item>
            </TooltipWrapper>
          ) : null}

          {isMaster(role) ||
          isAdmin(role) ||
          hasPermission(permissionActive, role._id, "data", "menu") ? (
            <TooltipWrapper collapsed={collapsed} content={t("data")}>
            <Dropdown
              trigger={
                <span style={{ display: "flex", alignItems: "center" }}>
                  <img src={iconDatos} alt="datos" className="menu-datos-icon" />
                  {!collapsed && t("data")}
                </span>
              }
              floating
              item
              className={
                isParentPath(
                  "/admin/data",
                  "/admin/config/configForms",
                  "/admin/config/conversionfactors",
                  "/admin/config/geifactors",
                  "/admin/config/gei-revision-calendar"
                )
                  ? "route-active"
                  : undefined
              }
            >
              <DropdownMenu>
                {isMaster(role) ||
                isAdmin(role) ||
                hasPermission(permissionActive, role._id, "data", "menu") ? (
                  <DropdownItem
                    as={Link}
                    to="/admin/data/productionforms"
                    active={isCurrentPath("/admin/data/productionforms")}
                  >
                    <SvgIcon src={iconProduccion} alt="produccion" />
                    {t("production")}
                  </DropdownItem>
                ) : null}
                {isMaster(role) ||
                isAdmin(role) ||
                hasPermission(permissionActive, role._id, "data", "menu") ? (
                  <DropdownItem
                    as={Link}
                    to="/admin/data/socialforms"
                    active={isCurrentPath("/admin/data/socialforms")}
                  >
                    <SvgIcon src={iconSocial} alt="social" />
                    {t("social")}
                  </DropdownItem>
                ) : null}

                {isMaster(role) ||
                isAdmin(role) ||
                hasPermission(permissionActive, role._id, "data", "menu") ? (
                  <DropdownItem
                    as={Link}
                    to="/admin/data/energyforms"
                    active={isCurrentPath("/admin/data/energyforms")}
                  >
                    <SvgIcon src={iconEnergia} alt="energia" />
                    {t("energy")}
                  </DropdownItem>
                ) : null}
                {isMaster(role) ||
                isAdmin(role) ||
                hasPermission(permissionActive, role._id, "data", "menu") ? (
                  <DropdownItem
                    as={Link}
                    to="/admin/data/fuelsforms"
                    active={isCurrentPath("/admin/data/fuelsforms")}
                  >
                    <SvgIcon src={iconVehiculos} alt="vehiculos" />
                    {t("fuels")}
                  </DropdownItem>
                ) : null}
                {isMaster(role) ||
                isAdmin(role) ||
                hasPermission(permissionActive, role._id, "data", "menu") ? (
                  <DropdownItem
                    as={Link}
                    to="/admin/data/waterforms"
                    active={isCurrentPath("/admin/data/waterforms")}
                  >
                    <SvgIcon src={iconAgua} alt="agua" />
                    {t("water")}
                  </DropdownItem>
                ) : null}
                {isMaster(role) ||
                isAdmin(role) ||
                hasPermission(permissionActive, role._id, "data", "menu") ? (
                  <DropdownItem
                    as={Link}
                    to="/admin/data/effluentforms"
                    active={isCurrentPath("/admin/data/effluentforms")}
                  >
                    <SvgIcon src={iconEfluentes} alt="efluentes" />
                    {t("effluent")}
                  </DropdownItem>
                ) : null}
                {isMaster(role) ||
                isAdmin(role) ||
                hasPermission(permissionActive, role._id, "data", "menu") ? (
                  <DropdownItem
                    as={Link}
                    to="/admin/data/wasteforms"
                    active={isCurrentPath("/admin/data/wasteforms")}
                  >
                    <SvgIcon src={iconResiduos} alt="residuos" />
                    {t("waste")}
                  </DropdownItem>
                ) : null}
               {isMaster(role) ||
                isAdmin(role) ||
                hasPermission(permissionActive, role._id, "data", "menu") ? (
                  // TODO: habilitar cuando el módulo esté listo
                  // <DropdownItem
                  //   as={Link}
                  //   to="/admin/data/airemissionsforms"
                  //   active={isCurrentPath("/admin/data/airemissionsforms")}
                  // >
                  //   <SvgIcon src={iconAireEmision} alt="aire" />
                  //   {t("airemissions")}
                  // </DropdownItem>
                  <DropdownItem disabled className="menu-item-wip">
                    <SvgIcon src={iconAireEmision} alt="aire" />
                    <span className="menu-item-wip__label">{t("airemissions")}</span>
                    <span className="menu-item-wip__badge">En desarrollo</span>
                  </DropdownItem>
                ) : null}

                {isMaster(role) ||
                isAdmin(role) ||
                hasPermission(permissionActive, role._id, "data", "menu") ? (
                  <DropdownItem
                    as={Link}
                    to="/admin/data/baseline"
                    active={isCurrentPath("/admin/data/baseline")}
                  >
                    {t("baseline")}
                  </DropdownItem>
                ) : null}

                {isMaster(role) ||
                isAdmin(role) ||
                hasPermission(permissionActive, role._id, "data", "menu") ? (
                  <DropdownItem
                    as={Link}
                    to="/admin/data/environmentalobjetives"
                    active={isCurrentPath("/admin/data/environmentalobjetives")}
                  >
                    {t("environmental_objectives")}
                  </DropdownItem>
                ) : null}

                {isMaster(role) ||
                isAdmin(role) ||
                hasPermission(permissionActive, role._id, "data", "menu") ? (
                  <DropdownItem disabled className="menu-item-wip">
                    <span className="menu-item-wip__label">{t("sbti")}</span>
                    <span className="menu-item-wip__badge">En desarrollo</span>
                  </DropdownItem>
                ) : null}

                {isMaster(role) ||
                isAdmin(role) ||
                hasPermission(permissionActive, role._id, "data", "menu") ? (
                  <DropdownItem disabled className="menu-item-wip">
                    <span className="menu-item-wip__label">{t("environmental_risk_matrix")}</span>
                    <span className="menu-item-wip__badge">En desarrollo</span>
                  </DropdownItem>
                ) : null}

                {isMaster(role) ||
                isAdmin(role) ||
                hasPermission(permissionActive, role._id, "data", "menu") ? (
                  <DropdownItem
                    as={Link}
                    to="/admin/data/energyperformance"
                    active={isCurrentPath("/admin/data/energyperformance")}
                  >
                    {t("energy_performance")}
                  </DropdownItem>
                ) : null}

                {isMaster(role) ||
                isAdmin(role) ||
                hasPermission(permissionActive, role._id, "data", "menu") ? (
                  <DropdownItem disabled className="menu-item-wip">
                    <span className="menu-item-wip__label">{t("water_balance_menu_label")}</span>
                    <span className="menu-item-wip__badge">En desarrollo</span>
                  </DropdownItem>
                ) : null}

                {isMaster(role) ||
                isAdmin(role) ||
                hasPermission(permissionActive, role._id, "data", "menu") ? (
                  <DropdownItem
                    as={Link}
                    to="/admin/document-manager"
                    active={isCurrentPath("/admin/document-manager")}
                  >
                    {t("document_manager")}
                  </DropdownItem>
                ) : null}

                {isMaster(role) ? (
                  <DropdownItem
                    as={Link}
                    to="/admin/config/duplicate-periods"
                    active={isCurrentPath("/admin/config/duplicate-periods")}
                  >
                    {t("duplicate_periods")}
                  </DropdownItem>
                ) : null}

                {isMaster(role) ||
                isAdmin(role) ||
                hasPermission(
                  permissionActive,
                  role._id,
                  "permissions",
                  "menu"
                ) ? (
                  <Dropdown
                    item
                    trigger={
                      <span style={{ display: "flex", alignItems: "center" }}>
                        <img src={iconDatos} alt="config" className="menu-datos-icon" />
                        {t("configure")}
                      </span>
                    }
                  >
                    <DropdownMenu>
                      <DropdownItem
                        as={Link}
                        to="/admin/config/configForms"
                        active={isCurrentPath("/admin/config/configForms")}
                      >
                        {t("configforms")}
                      </DropdownItem>
                      <DropdownItem
                        as={Link}
                        to="/admin/config/conversionfactors"
                        active={isCurrentPath("/admin/config/conversionfactors")}
                      >
                        {t("conversion_factors")}
                      </DropdownItem>
                      <DropdownItem
                        as={Link}
                        to="/admin/config/geifactors"
                        active={isCurrentPath("/admin/config/geifactors")}
                      >
                        Factores GEI
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                ) : null}

              </DropdownMenu>
            </Dropdown>
            </TooltipWrapper>
          ) : null}

          {/* {isMaster(role) ||
          isAdmin(role) ||
          hasPermission(permissionActive, role._id, "data", "menu") ? (
            <TooltipWrapper collapsed={collapsed} content={t("sbti")}>
              <Menu.Item
                as={Link}
                to="/admin/data/sbti"
                active={isCurrentPath("/admin/data/sbti")}
                className="admin-nav-item"
              >
                {!collapsed && t("sbti")}
              </Menu.Item>
            </TooltipWrapper>
          ) : null} */}

          {/* Usuarios – antes ítem standalone; ahora consolidado en Configuración */}
          {/* {isMaster(role) ||
          isAdmin(role) ||
          hasPermission(permissionActive, role._id, "users", "menu") ? (
            <TooltipWrapper collapsed={collapsed} content={t("users")}>
              <Menu.Item
                as={Link}
                to="/admin/users"
                active={isCurrentPath("/admin/users")}
                className="admin-nav-item"
              >
                {!collapsed && t("users")}
              </Menu.Item>
            </TooltipWrapper>
          ) : null} */}

          {isMaster(role) ||
          isAdmin(role) ||
          hasPermission(permissionActive, role._id, "reports", "menu") ? (
            <TooltipWrapper collapsed={collapsed} content={t("reports")}>
              <Menu.Item
                as={Link}
                to="/admin/reports"
                active={isCurrentPath("/admin/reports")}
                className="admin-nav-item"
              >
                {!collapsed && t("reports")}
              </Menu.Item>
            </TooltipWrapper>
          ) : null}

          {/* Empresas – antes ítem standalone; ahora consolidado en Configuración */}
          {/* {isMaster(role) ||
          hasPermission(permissionActive, role._id, "users", "menu") ? (
            <TooltipWrapper collapsed={collapsed} content={t("companies")}>
              <Menu.Item
                as={Link}
                to="/admin/companies"
                active={isCurrentPath("/admin/companies")}
                className="admin-nav-item"
              >
                {!collapsed && t("companies")}
              </Menu.Item>
            </TooltipWrapper>
          ) : null} */}

          {/* Sitios – antes ítem standalone; ahora consolidado en Configuración */}
          {/* {isMaster(role) ||
          (isAdmin(role) && company) ||
          hasPermission(permissionActive, role._id, "sites", "menu") ? (
            <TooltipWrapper collapsed={collapsed} content={t("sites")}>
              <Menu.Item
                as={Link}
                to="/admin/sites"
                active={isCurrentPath("/admin/sites")}
                className="admin-nav-item"
              >
                {!collapsed && t("sites")}
              </Menu.Item>
            </TooltipWrapper>
          ) : null} */}

          {/* Configuración (isMaster) – antes dropdown independiente con Roles y Permisos;
              ahora consolidado en el dropdown unificado de Configuración */}
          {/* {isMaster(role) ? (
            <TooltipWrapper collapsed={collapsed} content={t("configure")}>
            <Dropdown
              item
              trigger={
                <span style={{ display: "flex", alignItems: "center" }}>
                  <img src={iconDatos} alt="config" className="menu-datos-icon" />
                  {!collapsed && t("configure")}
                </span>
              }
            >
              <DropdownMenu>
                <DropdownItem
                  as={Link}
                  to="/admin/config/roles"
                  active={isCurrentPath("/admin/config/roles")}
                >
                  {t("roles")}
                </DropdownItem>
                <DropdownItem
                  as={Link}
                  to="/admin/config/permissions"
                  active={isCurrentPath("/admin/config/permissions")}
                >
                  {t("permissions")}
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
            </TooltipWrapper>
          ) : null} */}

          {/* ── Configuración unificada ──
              Consolida: Empresas, Sitios, Usuarios (todos los roles),
              + Roles y Permisos (solo isMaster) */}
          {isMaster(role) ||
          isAdmin(role) ||
          hasPermission(permissionActive, role._id, "users", "menu") ||
          hasPermission(permissionActive, role._id, "sites", "menu") ? (
            <TooltipWrapper collapsed={collapsed} content={t("configure")}>
              <Dropdown
                floating
                item
                trigger={
                  <span style={{ display: "flex", alignItems: "center" }}>
                    <img src={iconDatos} alt="config" className="menu-datos-icon" />
                    {!collapsed && t("configure")}
                  </span>
                }
                className={isParentPath(
                  "/admin/companies",
                  "/admin/integrations",
                  "/admin/sites",
                  "/admin/users",
                  "/admin/config/roles",
                  "/admin/config/permissions",
                  "/admin/config/gei-revision-calendar"
                ) ? "route-active" : undefined}
              >
                <DropdownMenu>
                  {isMaster(role) ||
                  hasPermission(permissionActive, role._id, "users", "menu") ? (
                    <DropdownItem
                      as={Link}
                      to="/admin/companies"

                      active={isCurrentPath("/admin/companies")}
                    >
                      {t("companies")}
                    </DropdownItem>
                  ) : null}

                  {isMaster(role) ? (
                    <DropdownItem
                      as={Link}
                      to="/admin/integrations"
                      active={isCurrentPath("/admin/integrations")}
                    >
                      {t("integrations")}
                    </DropdownItem>
                  ) : null}

                  {isMaster(role) ||
                  (isAdmin(role) && company) ||
                  hasPermission(permissionActive, role._id, "sites", "menu") ? (
                    <DropdownItem
                      as={Link}
                      to="/admin/sites"
                      active={isCurrentPath("/admin/sites")}
                    >
                      {t("sites")}
                    </DropdownItem>
                  ) : null}

                  {isMaster(role) ||
                  isAdmin(role) ||
                  hasPermission(permissionActive, role._id, "users", "menu") ? (
                    <DropdownItem
                      as={Link}
                      to="/admin/users"
                      active={isCurrentPath("/admin/users")}
                    >
                      {t("users")}
                    </DropdownItem>
                  ) : null}

                  {isMaster(role) ? (
                    <DropdownItem
                      as={Link}
                      to="/admin/config/roles"
                      active={isCurrentPath("/admin/config/roles")}
                    >
                      {t("roles")}
                    </DropdownItem>
                  ) : null}

                  {isMaster(role) ? (
                    <DropdownItem
                      as={Link}
                      to="/admin/config/permissions"
                      active={isCurrentPath("/admin/config/permissions")}
                    >
                      {t("permissions")}
                    </DropdownItem>
                  ) : null}

                  {isMaster(role) ? (
                    <DropdownItem
                      as={Link}
                      to="/admin/config/gei-revision-calendar"
                      active={isCurrentPath("/admin/config/gei-revision-calendar")}
                    >
                      Calendario GEI
                    </DropdownItem>
                  ) : null}
                </DropdownMenu>
              </Dropdown>
            </TooltipWrapper>
          ) : null}
        </>
      }
    </Menu>
    <PeerAppButton collapsed={collapsed} />
    </div>
  );
}
